var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",attrs:{"id":"app"}},[_c('webapp-header'),_c('router-view'),_c('webapp-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }